import { Box } from '@mui/material';
import React from 'react';


const StyledPage = ({
    children
  }) => (
    <Box
        sx={{
            maxWidth: '960px',
            margin: '0 auto',
            width: 'auto',
            padding: 3
        }}
    >
        {children}
    </Box>
   
)

export default StyledPage;